import React from 'react';
import {
  Select,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from '@mui/material';
import { PropTypes } from 'prop-types';

import '../common.scss';
import './Select.scss';

export default function CsrmSelect({
  selectedDataTypes,
  onSelect,
  dataTypeOptions,
}) {
  const itemHeight = 48;
  const itemPaddingTop = 8;
  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: itemHeight * 4.5 + itemPaddingTop,
        width: 250,
      },
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
  };

  return (
    <div className="csrm-select">
      <Select
        className="no-outline"
        multiple
        value={selectedDataTypes}
        onChange={(evt) => onSelect(evt.target?.value)}
        displayEmpty
        renderValue={() => 'Add Chart'}
        MenuProps={menuProps}
        variant="outlined"
      >
        {dataTypeOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <ListItemIcon>
              <Checkbox
                checked={selectedDataTypes.indexOf(option.value) > -1}
              />
            </ListItemIcon>
            <ListItemText primary={option.name} />
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}

CsrmSelect.propTypes = {
  selectedDataTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
  dataTypeOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
};
